module.exports = __webpack_public_path__ + "static/media/22-elleve.580d989a.mp3";